import type {
  CropArea,
  ImageTransform,
} from '@modules/_shared/components/image-upload/types';

type BuildImageTransformOptions = {
  hasUserInteracted: boolean;
  cropArea: CropArea | null;
  scale: number;
  initialScale: number;
  rotation?: number;
};

export const buildImageTransform = ({
  hasUserInteracted,
  cropArea,
  scale,
  initialScale,
  rotation,
}: BuildImageTransformOptions): ImageTransform => {
  if (!hasUserInteracted) {
    return {};
  }

  return {
    ...(cropArea ? { crop: cropArea } : {}),
    ...(scale !== initialScale ? { scale } : {}),
    ...(rotation !== undefined && rotation !== 0 ? { rotate: rotation } : {}),
  };
};
